import { useState, useEffect } from 'react';
import DownloadService from '@cora/download-center';
import useRootAppStore from './use-root-app-store';
import useCheckPoolingRoutes from './use-check-pooling-routes';
import { getLinkReplaced } from './methods';
const getPoolingInterval = (intervalConfigSeconds) => {
    const defaultInterval = 60 * 1000;
    const interval = intervalConfigSeconds < 1 ? defaultInterval : intervalConfigSeconds * 1000;
    return interval;
};
export default function useDownloadService() {
    const [downloadList, setDownloadList] = useState([]);
    const [statusBadge, setStatusBadge] = useState();
    const { ui } = useRootAppStore();
    const [interval, setPoolingInterval] = useState(getPoolingInterval(ui.downloadCenterNotificationPoolingIntervalSeconds));
    const ds = DownloadService.getInstance();
    ds.setApiUrl(ui.downloadCenterBaseApi);
    useEffect(() => {
        ds.setRequestApi((url, init) => {
            return rFetch(url, init);
        });
        ds.onError(() => {
            ds.stopPolling();
        });
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (ds.data === null) {
                return;
            }
            setDownloadList(ds.data.files);
            setStatusBadge(ds.data.status);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);
    const checkedEnablePooling = useCheckPoolingRoutes(ui.downloadCenterEnabledPaths);
    useEffect(() => {
        if (checkedEnablePooling) {
            ds.startPolling(interval);
        }
        else {
            ds.stopPolling();
        }
    }, [checkedEnablePooling]);
    useEffect(() => {
        ds.setPoolingInterval(getPoolingInterval(interval));
    }, [interval]);
    const retryDownload = (id) => {
        ds.reprocessFile(id);
    };
    const cancelDownload = (id) => {
        ds.cancelProcessing(id);
    };
    const downloadWithIFrame = (uri) => {
        const id = 'download-iframe';
        let ifrm = document.getElementById(id);
        if (ifrm == null) {
            ifrm = document.createElement('iframe');
            ifrm.setAttribute('id', 'download-iframe');
            ifrm.style.display = 'none';
            document.body.appendChild(ifrm);
        }
        ifrm.setAttribute('src', uri);
    };
    const getDownloadLink = async (id) => {
        try {
            const uri = await ds.generateDownloadLink(id);
            const replacedUri = getLinkReplaced(uri.link);
            downloadWithIFrame(replacedUri);
        }
        catch (error) {
            console.log(error);
        }
    };
    return {
        downloadList,
        statusBadge,
        retryDownload,
        getDownloadLink,
        cancelDownload,
        setPoolingInterval,
    };
}
//# sourceMappingURL=use-download-service.js.map